import { render, staticRenderFns } from "./BanSearch.vue?vue&type=template&id=68be4806&"
import script from "./BanSearch.vue?vue&type=script&lang=js&"
export * from "./BanSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports